import { View, StyleSheet, Platform, Dimensions } from 'react-native'
import { useTheme } from '@react-navigation/native';
import RNPickerSelect from "react-native-picker-select";
import React from 'react';
import Ionicons from "@react-native-vector-icons/ionicons/static";
var width = Dimensions.get('window').width;

// * Language 
import { useTranslation } from 'react-i18next';

const CustomDropDown = ({ defValue, setValue, options, disabled = false, type = "PRIMARY", label = null }) => {

  const { t } = useTranslation();
  const { colors } = useTheme()
  const styles = makeStyles(colors);
  const pickerSelectStyles = pickerSelectStyle(colors);

  if (options == undefined)
    return;
  return (
    <View
      style={[
        styles.container,
        styles[`container_${type}`],
      ]}>
      <RNPickerSelect
        useNativeAndroidPickerStyle={false}
        fixAndroidTouchableBug={true}
        disabled={disabled}
        placeholderTextColor="#a1a1a1"
        placeholder={{
          label: label !== null ? label : t('common:selectItem'),
          value: '',
          color: '#a1a1a1'
        }}
        value={defValue}
        style={{
          ...pickerSelectStyles,
          iconContainer: {
            paddingVertical: 3,
            paddingHorizontal: 5,
          },
        }}
        items={options}
        Icon={() => {
          return Platform.OS !== 'web' && <Ionicons
            name="chevron-down"
            style={styles.icon}
          />
        }}
        onValueChange={(value) =>
          setValue(value)
        }
      />
    </View>
  )
};
const makeStyles = (colors) =>
  StyleSheet.create({
    container_SM_MYPROFILE: {
      flex: 1,
      borderRadius: 10,
      borderWidth: 2,
      width: "88%",
      padding: 10,
    },

    input_SM_MYPROFILE: {
      flex: 1,
      fontSize: 16,
      color: colors.text_primary,
      paddingHorizontal: 0,
    },

    container: {
      backgroundColor: colors.background_dropdown,
      borderRadius: 10,
      borderWidth: 1.5,
      borderColor: colors.border_card,
      padding: Platform.OS === "web" && width > 1300 ? 7 : 10,
      paddingHorizontal: Platform.OS !== "web" && width > 1300 ? 10 : 7,
      marginVertical: 5,
      shadowColor: 'rgba(92, 143, 26, 1)',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.06,
      shadowRadius: 8,
      elevation: 2,

    },

    container_PART: {
      borderRadius: 10,
      borderWidth: 2,
      borderColor: "#e8e8e8",
      justifyContent: "center",
      // margin: 10,
    },

    input_PART: {
      fontSize: 16,
      color: colors.text_primary,
    },

    container_PRIMARY: {
      // Button Deloitte
      width: "60%",
    },

    container_FULL: {
      flex: 1,
      width: "94%",
      marginLeft: "3%",
      marginRight: "1%",
      paddingVertical: Platform.OS === "web" && width > 1300 ? 5 : 7,
      marginBottom: 15,

      zIndex: 5000,
      elevation: 5000,
      position: 'relative',
    },

    container_ASSM: {
      flex: 1,
      marginLeft: "3%",
      marginRight: "1%",
      paddingVertical: Platform.OS === "web" && width > 1300 ? 5 : 7,
      marginBottom: "-1%",
    },

    container_RESULTS: {
      flex: Platform.OS !== "web" ? 1 : 100,
      width: "100%",
      marginLeft: "3%",
      marginRight: "1%",
      paddingVertical: Platform.OS === "web" && width > 1300 ? 5 : 7,
      marginBottom: "-1%",
    },

    container_MYPROFILE: {
      flex: 1,
      width: "98%",
      borderRadius: 10,
      borderWidth: 2,
      padding: 10,
    },

    container_ERROR: {
      flex: 1,
      width: "98%",
      backgroundColor: colors.background_dropdown,
      borderColor: 'red',
      borderRadius: 10,
      borderWidth: 1,
      padding: 10,
    },

    container_ASSESSMENT: {
      flex: 1,
      width: "100%",
      height: "6%",
      borderRadius: 10,
      borderWidth: 2,
      padding: 10,
    },

    container_MODAL: {
      borderRadius: 5,
      borderWidth: Platform.OS === "web" && width > 1300 ? 0 : 2,
      backgroundColor:
        Platform.OS === "web" && width > 1300
          ? "transparent"
          : colors.background_dropdown,
    },

    container_CALENDAR: {
      flex: 1,
    },

    container_TIMESHEET: {

    },

    input_TIMESHEET: {
      fontSize: 16,
      color: colors.text_primary,
      paddingHorizontal: 0,
    },

    container_BRANCHES: {
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      flex: 1,
      borderRadius: 10,
      width: "90%",
      marginHorizontal: "3%",
      marginVertical: 15,
      padding: 15,
    },

    input_BRANCHES: {
      flex: 1,
      fontSize: 17,
    },

    icon: {
      fontSize: 20,
      color: "#a1a1a1",
    },
    container_ARRAYDROPDOWN: {
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      flex: 1,
      borderRadius: 10,
      borderWidth: 2,
      padding: 12,
      margin: 10,
    },

    container_REVIEWS1: {
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      flex: 1,
      borderRadius: 10,
      borderWidth: 2,
      padding: 12
    },

    container_REVIEWS: {
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      flex: 1,
      borderRadius: 10,
      marginBottom: 15,
      borderWidth: 2,
      padding: 12
    },

    container_NEW_COMPANY: {
      flex: 1,
      borderRadius: 10,
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      backgroundColor: colors.background_card,
      borderRadius: 10,
      borderWidth: 2,
      padding: 10,
    },

    container_EDIT_EMPLOYEE: {
      borderRadius: 10,
      borderWidth: 2,
      flex: 1,
      width: "100%",
      padding: 7,
      margin: 5,
    },

    container_SERVICE_LINES: {
      flex: 1,
    },

    container_DEPARTMENTS: {
      flex: 1,
    },

    container_MASS_UPLOAD: {
      flex: 1,
      width: "70%",
      borderRadius: 10,
      borderWidth: 2,
      padding: 10,
    },
    container_TIMESCHEMES: {
      borderWidth: 2,
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      flex: 1,
      borderRadius: 10,
      width: "100%",
      marginLeft: "3%",
      padding: 15,
    },
    container_MODALWKFL: {
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      flex: 1,
      borderRadius: 10,
      padding: 12,
      width:'100%'
    },
  });

const pickerSelectStyle = (colors) => StyleSheet.create({

  inputIOS: {
    fontSize: 16,
    borderRadius: 10,
    borderColor: colors.border_card,
    borderWidth: 2,
    paddingVertical: 10,
    paddingHorizontal: 6,
    color: colors.text_primary,
    backgroundColor: colors.background_dropdown,
    paddingRight: 30, // to ensure the text is never behind the icon
    paddingLeft: 10,
    fontFamily: 'Roboto-Medium',
    overflow: 'hidden', // to hide overflow text
    textOverflow: 'ellipsis', // to add ellipsis for overflow text
  },

  inputAndroid: {
    fontSize: 16,
    color: colors.text_primary,
    paddingHorizontal: 5,
    backgroundColor: colors.background_dropdown,
    paddingRight: 30, // to ensure the text is never behind the icon
    fontFamily: 'Roboto-Medium',
    overflow: 'hidden', // to hide overflow text
    textOverflow: 'ellipsis', // to add ellipsis for overflow text
  },

  inputWeb: {
    fontSize: 16,
    color: colors.text_primary,
    paddingHorizontal: 5,
    backgroundColor: colors.background_dropdown,
    paddingRight: 30, // to ensure the text is never behind the icon
    fontFamily: 'Roboto-Medium',
    outlineStyle: 'none',    // remove dropdown outline
    borderColor: colors.background_dropdown,
    marginRight: 5,
    overflow: 'hidden', // to hide overflow text
    textOverflow: 'ellipsis', // to add ellipsis for overflow text
  },

  placeholder: {
    color: '#a1a1a1',
  },
});


export default CustomDropDown;